module.exports = __webpack_public_path__ + "static/media/cat.92516e11.svg";